import React from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import EpdRoutes from 'routes/EpdRoutes';
import AuthStatusPage from 'components/auth/AuthStatusPage';
import { HyperLink } from 'styles/Styles.styled';

const RegisterUserError: React.FC<RouteComponentProps> = () => {
  return (
    <AuthStatusPage
      imageType="error"
      imageAlt="Error"
      title="Something went wrong"
      message="An unexpected error occurred. Please try again."
      link={
        <HyperLink as={Link} to={EpdRoutes.login}>
          Back to login page
        </HyperLink>
      }
    />
  );
};

export default RegisterUserError;
